import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

export default function Categories() {
  const { slug } = useParams();
  const API_URL = process.env.REACT_APP_API_URL;

  const [activeTab, setActiveTab] = useState("women");
  const [products, setProducts] = useState([]);
  const [colors, setColors] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);

  /* -------------------- LOAD COLORS -------------------- */
  useEffect(() => {
    axios
      .get(API_URL + "colors")
      .then((res) => {
        setColors(res.data.data || res.data);
      })
      .catch((err) => {
        console.error("Failed to load colors", err);
      });
  }, [API_URL]);

  /* -------------------- LOAD PRODUCTS -------------------- */
  useEffect(() => {
    axios
      .get(API_URL + "products", {
        params: {
          gender: activeTab === "men" ? "male" : "female",
          category: slug,
          color: selectedColors.join(","),
        },
      })
      .then((res) => {
        setProducts(res.data.data);
      })
      .catch((err) => {
        console.error("Failed to load products", err);
      });
  }, [activeTab, slug, selectedColors, API_URL]);

  /* -------------------- HANDLE COLOR FILTER -------------------- */
  const handleColorChange = (colorSlug) => {
    setSelectedColors((prev) =>
      prev.includes(colorSlug)
        ? prev.filter((c) => c !== colorSlug)
        : [...prev, colorSlug]
    );
  };

  const toggleDropdown = () => {
    setOpenDropdown(openDropdown ? null : "colors");
  };

  return (
    <>
      {/* --------------------- HERO SECTION --------------------- */}
      <div style={{ width: "100%", overflow: "hidden" }}>
        <img
          src="/images/categories/hero.jpg"
          alt="Collection Banner"
          style={{ width: "100%", height: "350px", objectFit: "cover" }}
        />
      </div>

      {/* --------------------- GENDER TABS --------------------- */}
      <ul className="nav justify-content-center mb-4 custom-tabs mt-4">
        <li className="nav-item">
          <button
            className={`nav-link custom-tab ${
              activeTab === "women" ? "active" : ""
            }`}
            onClick={() => setActiveTab("women")}
          >
            Women
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link custom-tab ${
              activeTab === "men" ? "active" : ""
            }`}
            onClick={() => setActiveTab("men")}
          >
            Men
          </button>
        </li>
      </ul>

      {/* --------------------- FILTER + PRODUCTS --------------------- */}
      <div className="container mt-5 mb-5">
        <div className="row">

          {/* -------------------- PRODUCT GRID -------------------- */}
          <div className="col-md-12">
            <div className="row g-4">
              {products.length > 0 ? (
                products.map((product) => (
                  <div key={product.id} className="col-lg-4 col-md-6">
                    <div className="card h-100 border-0 shadow-sm">
                      <Link to={`/product/${product.slug}`}  style={{ textDecoration: "none", color: "inherit" }}>
                      <img
                        src={product.primary_image?.image_url}
                        alt={product.name}
                        className="card-img-top rounded"
                        style={{ objectFit: "cover", height: "250px" }}
                      />
                      <div className="card-body text-center">
                        <h6 className="fw-bold">{product.name}</h6>
                        {product.catalogue_no && (
                          <p className="text-muted">Catalogue No : {product.catalogue_no}</p>
                        )}
                      </div>
                      </Link>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-5">
                  <h5>No products found</h5>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
